/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

import { useState, useEffect } from '@wordpress/element';

import apiFetch from '@wordpress/api-fetch';

import {
	RadioControl,
	RangeControl,
	TextControl,
	PanelBody,
	ColorPicker, ColorPalette,
	CheckboxControl, ToggleControl,
	TabPanel,
	SelectControl,
	Button, Icon,
	Spinner,
	Notice,
	ToolbarGroup, ToolbarButton, Dropdown, DropdownMenu,
	Popover,
	Disabled,
	__experimentalNumberControl as NumberControl,
	__experimentalAlignmentMatrixControl as AlignmentMatrixControl,
	__experimentalText as Text
} from "@wordpress/components";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	MediaPlaceholder,
	InspectorControls,
	BlockControls,
	__experimentalLinkControl as LinkControl
} from '@wordpress/block-editor';

import { keyboardReturn } from '@wordpress/icons';

import FontPicker from "font-picker-react";

// auto caption colors
import * as Vibrant from 'node-vibrant'

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * Amplify push messaging
 *
 */
import { imgwb_subscribe } from './imgwb_sync';

import { select, subscribe } from '@wordpress/data';

// stickers
const variant_template_settings = {
	'baseline' : ['baseline'],
	'focus' : ['focus', 'captions'],
	'slideshow' : ['slideshow', 'captions'],
	'crossfade' : ['crossfade', 'captions'],
	'shuffle' : ['captions'],
	'interact' : ['captions']
};

// detect browser compatibility
let _accepts = ['image/svg+xml', 'image/jpeg'];
// because fetch will not behave like an img request
let _test_avif = new Image();
_test_avif.onload = function () {
	_accepts.push('image/avif');
};
_test_avif.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";

let _test_webp = new Image();
_test_webp.onload = function () {
	_accepts.push('image/webp');
};
_test_webp.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";


export default function Edit({ attributes, setAttributes, isSelected }) {

	const [ statusNoticeLevel, setStatusNoticeLevel ] = useState();
	const [ statusNotice, setStatusNotice ] = useState();
	const [ statusActions, setStatusActions ] = useState([]);

	const [ mainNavTab, setMainNavTab ] = useState();

	// status until from_src triggers api post
	const [ blobUrl, setBlobUrl ] = useState();

	// media placeholder toggle
	const [ showAddVariant, setShowAddVariant ] = useState(false);

	// which caption is being edited?
	const [ captionIdx, setCaptionIdx ] = useState(0);

	// from backend
	const [ config, setConfig ] = useState({})

	// view/click
	const [ viewTotal, setViewTotal ] = useState(0)

	// are we showing deleted variants?
	const [ showDeletedVariants, setShowDeletedVariants ] = useState(false);

	// detect country and cdn status
	const [ speed, setSpeed ] = useState({});

	// analysis of each image colors for captions
	const [ palettes, setPalettes ] = useState({});

	// animation restart counter
	const [ animationRestart, setAnimationRestart ] = useState();

	// sticky tab
	const [ variantSettingsTab, setVariantSettingsTab ] = useState();

	// suggestion idx
	const [ suggestionIdx, setSuggestionIdx ] = useState(0);

	// open ai
	const [ isWordsInputVisible, setIsWordsInputVisible ] = useState(false);
	const [ mediaWords, setMediaWords ] = useState();
	const [ mediaCreating, setMediaCreating ] = useState(false);
	const [ evolvePrompt, setEvolvePrompt ] = useState();

	// regen state
	const [ isSavingProcess, setSavingProcess ] = useState(false);

	// appsync resubscribe
	const [ appsyncResub, setAppsyncResub ] = useState();

	// various variant subsets
	const [ primary_variant_id, setPrimaryVariantId ] = useState();
	const [ primary_variant, setPrimaryVariant ] = useState();
	const [ suggested_variants, setSuggestedVariants ] = useState([]);
	const [ inactive_variants_count, setInactiveVariantsCount ] = useState(0);
	const [ winning_variant, setWinningVariant ] = useState();
	const [ best_variants, setBestVariants ] = useState([]);
	const [ combo_variants, setComboVariants ] = useState([])

	// edge policy refresh
	const [ edgePolicy, setEdgePolicy ] = useState({});

	// [runonce] get speed.country and set color palettes
	useEffect(() => {
		fetch('https://api.imgwb.com/speed')
			.then((response) => response.json())
			.then(function(data) {
				//console.log('runonce/speed', data);
				setSpeed(data.speed);
			})

		// get color palettes
		if (attributes.src) {
			setVariantPalettes(attributes.variants);
		}
	}, []);

	// [from_src] => POST new image or variant and set image_id
	// triggered from addMedia or transform/from or variant/Duplicate
	useEffect(() => {
		// check visibility of preview pane so we can ignore Preview
		const isTransformPreview = document.querySelector('.is-selected.wp-block-image');
		if (!attributes.from_src || isTransformPreview || attributes.image_id == 'example') {
			return;
		}

		// hide Add Media
		setShowAddVariant(false);

		function removeNewVariant() {
			console.log('removing new!');

			const new_variants = attributes.variants;

			if ('new' in new_variants) {
				delete new_variants['new'];

				const variant_id_remaining = Object.keys(new_variants);

				setAttributes({
					variant_id: variant_id_remaining.length ? variant_id_remaining[0] : null,
					variants: new_variants
				});
			}
		}

		// do we have a label?
		let post_params = {};
		if (typeof attributes.variants['new']?.label != 'undefined') {
			post_params['label'] = attributes.variants['new'].label;
		}

		// post image/variant
		if (!attributes.image_id || attributes.image_id == 'new') {
			// new image
			console.log('useEffect2 /image', attributes.from_src);

			// in case we need to transfer/to image later
			setAttributes({
				to_src: attributes.from_src
			});

			apiFetch({
				path: '/imgwb_image_plus/api/image',
				method: 'POST',
				data: {
					...post_params,
					source_url: attributes.from_src
				}
			}).then(function(response) {
				console.log('POST /image response', response);

				if (response.error) {
					setStatusNoticeLevel('error');
					setStatusNotice(response.error.message);
					setStatusActions(response.error.actions);

					// remove 'new' variant
					removeNewVariant()

				} else if (response.image.image_id) {
					let variant_id = response.variant.variant_id;
					let variants = {
						[variant_id]: response.variant
					}

					// add imported/transformed caption
					if (attributes.variants['new']?.params?.captions) {
						variants[variant_id].params = {
							captions: attributes.variants['new'].params.captions
						}
					}

					setAttributes({
						cache_ver: String(Date.now()).substring(0, 10),
						// reset to null so it's possible to upload duplicate
						from_src: null,
						// updating image_id will trigger a GET and subscribe to push
						image_id: response.image.image_id,
						src: response.image.src,
						variant_id: variant_id,
						variants: variants
					});
				}
			})

		} else {
			// new variant
			console.log('useEffect2 /variant', attributes.from_src);

			apiFetch({
				path: '/imgwb_image_plus/api/variant',
				method: 'POST',
				data: {
					...post_params,
					image_id: attributes.image_id,
					source_url: attributes.from_src
				}
			}).then(function(response) {
				console.log('POST /variant response', response);

				if (response.error) {
					setStatusNoticeLevel('error');
					setStatusNotice(response.error.message);
					setStatusActions(response.error.actions);

					// remove 'new' variant
					removeNewVariant()

				} else if (response.variant.variant_id) {
					const variant_id = response.variant.variant_id;

					// add imported/transformed caption
					let variant = response.variant;
					if (attributes.variants['new']?.params?.captions) {
						variant.params = {
							captions: attributes.variants['new'].params.captions
						}
					}

					let new_variants = {};
					Object.entries(attributes.variants).forEach(function([variant_id, variant]) {
						if (variant_id != 'new') new_variants[variant_id] = variant;
					});

					setAttributes({
						cache_ver: String(Date.now()).substring(0, 10),
						// reset to null so it's possible to upload duplicate
						from_src: null,
						variant_id: variant_id,
						variants: {
							...new_variants,
							[variant_id]: variant
						}
					});
				}
			})
		}
	}, [attributes.from_src]);

	// [image_id] => GET image config from backend, and subscribe to server push
    useEffect(() => {
        if (!attributes.image_id || attributes.image_id == 'new' || attributes.image_id == 'example') {
        	console.log('useEffect3 - skipping image_id', attributes.image_id);
        	return;
        }

        // GET image details - either on page refresh, or after server tells us the new image_id
		function fetchConfig() {
			apiFetch({
				path: `/imgwb_image_plus/api/image/${ attributes.image_id }?projection=config`
			}).then(function(response) {
				console.log('GET /image/', attributes.image_id, '?projection=config', response);
				if (response.error) {
					setStatusNoticeLevel('error');
					setStatusNotice(response.error.message);
					setStatusActions(response.error.actions);

				} else {
					setConfig(response.image.config);
				}
			})
		}
		// page refresh
		fetchConfig();

		// subscribe for server push for new images compiling
        const subscription = imgwb_subscribe(attributes.image_id, function(data) {
        	//setConfig(JSON.parse(data.config));
        	console.log('appsync!');
        	fetchConfig();
        }, function(error) {
        	console.log('appsync error:', error, 'resubscribe');
        	// resubscribe
			setTimeout(function() {
				setAppsyncResub(Date.now());
			}, 5000);
        });

        return () => subscription.unsubscribe()
    }, [attributes.image_id, appsyncResub])

	// [config] => merge config from backend with client-side attributes
	useEffect(() => {
		if (typeof config.variants == 'undefined') {
			// empty config - nothing to do
			return;
		}

		// config might have new variants
		// local params (and deleted status) have precedence
		let new_variants = {};
		let total_views = 0;

		Object.entries(config.variants).forEach(function([variant_id, variant]) {

			if (attributes.variants[variant_id]?.params) {
				// variant originated from client
				new_variants[variant_id] = {
					...variant,
					variant_id: variant_id,
					params: attributes.variants[variant_id]?.params
				}
			} else {
				// suggested variant originated from AI
				new_variants[variant_id] = {
					...variant,
					variant_id: variant_id
				}
			}

			// maintain deletion even before post is saved
			if (attributes.variants[variant_id]?.variant_status == 'inactive') {
				new_variants[variant_id].variant_status = 'inactive';
			}

			// maintain local label
			if (attributes.variants[variant_id]?.label) {
				new_variants[variant_id].label = attributes.variants[variant_id].label;
			}

			const views = getRollingViewCount(variant);
			total_views += views;

			// detect change of svg_version
			if (variant.svg_version && attributes.variants[variant_id]?.svg_version && variant.svg_version != attributes.variants[variant_id]?.svg_version) {
				//new_variants[variant_id].variant_status = 'regenerating';

				// kickoff cloudfront policy refresh and check
				setTimeout(function() {
					edgePolicyRefresh(variant_id, variant.svg_version);
				}, 5000);
			}

			// calc ctor and winning variant
			new_variants[variant_id].ctvr = views ? 100*(variant.clicks_rolling?.click_web || 0) / views : 0;
		});

		// get color palettes
		setVariantPalettes(config.variants);

		// view/click stats
		setViewTotal(total_views);

		setAttributes({
			src: config.src,
			instant_load_src: config.instant_load_src,
			variants: new_variants
		});

	}, [config])

	// [params] => caption-sizing can only be done after font/text is rendered
	useEffect(() => {
		if (attributes.image_id == 'example') {
			// skip example
			return;
		}

		// right-size caption backgrounds
		let new_captions = [];
		let captions_resized = false;
		document.querySelectorAll('.imgwb-variant-editing text').forEach(function(_text, _idx) {
			const variant_id = _text.dataset.variant;
			if (variant_id == attributes.variant_id) {
				const caption = attributes.variants[attributes.variant_id].params.captions[_idx];
				const _text_bb = _text.getBBox();
				const new_width = parseInt(_text_bb.width + _text_bb.height/2);
				const new_height = parseInt(1.2 * _text_bb.height);

				if (caption) {
					new_captions.push({
						...caption,
						width: new_width,
						height: new_height
					})

					if (caption.width != new_width || caption.height != new_height) {
						captions_resized = true;
					}
				}

			}
		});

		// save to attributes
		if (captions_resized) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[attributes.variant_id] : {
						...attributes.variants[attributes.variant_id],
						params: {
							...attributes.variants[attributes.variant_id]?.params,
							captions: new_captions
						}
					}
				}
			});
		}
	}, [attributes.variants[attributes.variant_id]?.params]);

	// [variant_id] => ensure variant is visible for editing, restart animation
	useEffect(() => {
		if (!attributes.variant_id) {
			return;
		}

		// needs a small timeout before the element is in DOM
		setTimeout(function() {
			const variant_editing = document.querySelector('.imgwb-variant-editing');

			if (variant_editing) {
				variant_editing.scrollIntoView({behavior:'smooth', block:'nearest'});
			}
		}, 25);

		// default settings tab if different template
		const variant = attributes.variants[attributes.variant_id];
		if (variant && variant.variant_template) {
			const tab_names = variant_template_settings[variant.variant_template];
			if (tab_names.indexOf(variantSettingsTab) == -1) {
				setVariantSettingsTab(tab_names[0]);
			}
		}

		// restart animations
		document.querySelectorAll('.imgwb-thumb svg, .wp-block-images-with-benefits-image-plus > svg').forEach(function(_el) {
			_el.dataset.restart = 0;
		});
		setAnimationRestart(Date.now());

	}, [attributes.variant_id, isSelected, showAddVariant]);

	// [animationRestart] => restart animations
	useEffect(() => {
		// restart svg animations
		// ref. https://stackoverflow.com/questions/24494010/how-to-reset-the-timer-of-svg-animation-when-using-beginelementat
		document.querySelectorAll('svg[data-restart]').forEach(function(_svg) {
			_svg.querySelectorAll('animate, animateTransform').forEach(function(_anim) {
				_anim.beginElementAt(parseFloat(_svg.dataset.restart));
			});
			delete _svg.dataset.restart;
		});

	}, [animationRestart]);

	// when saving/auto-saving, note svg versions so we can detect which variants are in regen, so we can flush cache
	useEffect(() => {
		if (isSavingProcess) {
			window.localStorage.setItem('imgwb-admin-save', parseInt(Date.now()/1000));
		}
	}, [isSavingProcess]);

	// find primary_variant and suggested_variants
	useEffect(() => {
		let suggested = [];
		let inactives = 0;
		let combos = [];

		for (let variant_id in attributes.variants) {
			const variant = attributes.variants[variant_id];

			if (variant.variant_type == 'primary') {
				setPrimaryVariantId(variant_id);
				setPrimaryVariant(variant);
			} else if (variant.variant_type == 'suggested') {
				suggested.push(variant);
			}

			if (variant.variant_status == 'inactive') {
				inactives += 1;
			}

			if (variant.variant_template == 'focus' && variant.variant_status == 'active' && variant.variant_type != 'baseline') {
				combos.push([variant_id, variant]);
			}
		}

		setSuggestedVariants(suggested);
		setInactiveVariantsCount(inactives);
		setComboVariants(combos);

		setBestVariants(Object.entries(attributes.variants).sort(([,a],[,b]) => (b.ctvr - a.ctvr)));
		if (best_variants.length) {
			setWinningVariant(best_variants[0][0]);
		}

	}, [attributes.variants]);

	// ---------------------------------
	// main React loop

	// get width or height of variant, or primary_variant if locked
	function variant_locked_field(variant, field) {
		console.log(variant);
		if (primary_variant && attributes.lock_aspect_ratio) {
			return primary_variant[field];
		} else {
			return variant[field];
		}
	}

	// refresh & check cloudfront policy
	function edgePolicyRefresh(variant_id, version_required) {
		const refresh_url = attributes.src.replace('/v:loading/', '/vw:admin/').replace('/view', '/refresh') + '?variant=' + variant_id + '&ts=' + Date.now();

		fetch(refresh_url, {
			headers: {
				'Accept': _accepts.join(',')
			},
			cache: 'reload'
		})
		.then(response => response.json())
		.then(function(result) {
			const min_svg_version = result.refresh.svg_version;

			if (min_svg_version < version_required) {
				console.log(variant_id, 'policy stale', min_svg_version, '<', version_required);
				setEdgePolicy({
					...edgePolicy,
					[variant_id] : 'stale'
				});

				// retry
				setTimeout(function() {
					edgePolicyRefresh(variant_id, version_required);
				}, 5000)

			} else {
				console.log(variant_id, 'policy fresh', version_required);
				setEdgePolicy({
					...edgePolicy,
					[variant_id] : 'fresh'
				});

				// signal viewer.js to force reload
				let variant_reloads = JSON.parse(window.localStorage.getItem('imgwb-variant-reloads') || '{}');
				variant_reloads[variant_id] = version_required;
				// clear old reloads
				variant_reloads = Object.fromEntries(Object.entries(variant_reloads).filter(([variant_id, ts]) => {
					return (Date.now()/1000 - ts) < 86400;
				}));
				window.localStorage.setItem('imgwb-variant-reloads', JSON.stringify(variant_reloads));
			}
		});
	}

	// for a dict of variants, set any palettes that are needed
	function setVariantPalettes(variants) {
		const variants_needing_palette = Object.entries(variants).filter(([variant_id, variant]) => {
			return !(variant_id in palettes) && variant.variant_template == 'focus' && variant.variant_type != 'baseline';
		});

		if (!variants_needing_palette.length) return;

		Promise.all(
			variants_needing_palette.map(([variant_id, variant]) => {
				let v = new Vibrant(getImageSrc(variant_id), {});
				return v.getPalette();
			})
		).then((results) => {
			let new_palettes = {};
			for (let idx = 0; idx < variants_needing_palette.length; idx++) {
				const variant_id = variants_needing_palette[idx][0];
				new_palettes[variant_id] = {};
					Object.entries(results[idx]).forEach(function([color_id, swatch]) {
						new_palettes[variant_id][color_id] = {
							'color': swatch.getHex(),
							'text_color': swatch.getTitleTextColor()
						}
					})
			}

			//console.log('setVariantPalettes', new_palettes);

			setPalettes({
				...palettes,
				...new_palettes
			});
		});
	}

	// excludes admin and loading views
	function getRollingViewCount(variant) {
		return (variant.views_rolling?.view_web || 0) + (variant.views_rolling?.view_cache || 0) + (variant.views_rolling?.view_http304 || 0) + (variant.views_rolling?.view_redirect || 0);
	}

	function getImageSrc(variant_id) {
		let src = attributes.src.replace('/v:loading/', '/vw:admin/').replace('/view','/w:2048/view?variant='+variant_id+'&codec=avif|webp|jpeg');

		// bust cache if more assets have since been created

		const ts = attributes.variants[variant_id]?.web_assets_updated || Date.now();
		if (ts) {
			src += '&ts=' + ts;
		}
		return src;
	}

	function renderStatusNotice() {
		function dismissStatusNotice() {
			setStatusNotice(null);
			setStatusNoticeLevel(null);
		}

		return (
			<Notice
				status={ statusNoticeLevel }
				actions={ statusActions }
				onDismiss={ () => dismissStatusNotice() }
			>
				<p>
					{ statusNotice }
				</p>
			</Notice>
		);
	}

	function addMedia(title, instructions) {
		/*
			url - blob or final uploaded image
			width
			height
			filesizeInBytes
			name, description, caption, alt
		*/
		function onSelectImage( media ) {
			console.log('onSelectImage', media);

			// detect blob - wait for upload
			if (media.url.indexOf('blob:') === 0) {
				setBlobUrl(media.url);
				return;
			} else {
				setBlobUrl(null);
			}

			const width = media.media_details?.width;
			const height = media.media_details?.height;
			const text = media.caption || media.alt || 'Call To Action';
			const font_size = parseInt(width / Math.max(8, text.length));

			const new_attributes = {
				from_src: media.url,
				variant_id: 'new',
				variants: {
					...attributes.variants,
					'new': {
						variant_status: 'loading',
						source_url: media.url,
						label: media.alt || 'New Image',
						width: width,
						height: height,
						params: {
							focus: {
								box: '400400200200:Center',
								zoom: 0.5,
								duration: 2
							}
						}
					}
				}
			}

			if (!attributes.image_id) {
				new_attributes.image_id = 'new';
			}

			setAttributes(new_attributes);
		}

		function onSelectURL( url, media_params={} ) {
			console.log('onSelectURL', url);

			const img = new Image();
			img.addEventListener("load", function() {
				console.log('onSelectURL loaded');
				onSelectImage({
					url: url,
					...media_params,
					media_details: {
						width: this.naturalWidth,
						height: this.naturalHeight
					}
				})
			});
			img.addEventListener("error", function() {
				setStatusNotice('Image not found! Please try another URL.');
				setStatusNoticeLevel('error');
				// TODO remove temp variant
			});

    		img.src = url;
		}

		// enable variantPreview while processing
		function temporaryPreview(src, label) {
			// excludes from_src: media.url,
			//
			console.log('temporaryPreview');
			setAttributes({
				variant_id: 'new',
				variants: {
					...attributes.variants,
					'new': {
						variant_status: 'loading',
						source_url: src,
						label: label || 'New Image'
					}
				}
			});
		}

		function onPromptImage(prompt) {
			setMediaCreating(true);

			apiFetch({
				path: '/imgwb_image_plus/api/openai',
				method: 'POST',
				data: {
					command: 'generations',
					prompt: prompt
				}
			}).then(function(response) {
				console.log('POST /openai response', response);

				if (response.error) {
					setMediaCreating(false);
					setStatusNoticeLevel('error');
					setStatusNotice(response.error.message);
					setStatusActions(response.error.actions);

					// remove 'new' variant
					removeNewVariant()

				} else if (response.openai.source_url) {
					temporaryPreview(response.openai.source_url, prompt);
					setMediaCreating(false);
					setShowAddVariant(false);

					onSelectURL(response.openai.source_url, {
						alt: prompt
					});
				}
			});

/*
{
  "error": {
    "code": null,
    "message": "Your request was rejected as a result of our safety system. Your prompt may contain text that is not allowed by our safety system.",
    "param": null,
    "type": "invalid_request_error"
  }
}
*/
		}

		function onUploadError( message ) {
			setStatusNotice(message);
			setStatusNoticeLevel('error');
		}

		function renderUploading() {
			return (
				<>
					<img src={ blobUrl } width="180" />
					<div>
						<Spinner/>
						<span style={{
							'vertical-align' : 'text-bottom'
						}}>Uploading...</span>
					</div>
				</>

			)
		}

		function onSubmitWords() {
			event.preventDefault();
			onPromptImage( mediaWords );
			closeWordsInput();
		}

		function closeWordsInput() {
			setIsWordsInputVisible(false);
		}

		const openai = (
			<div className="imgwb-media-create-container">
				{ !mediaCreating &&  <Button
					className="block-editor-media-placeholder__button"
					onClick={ () => setIsWordsInputVisible(true) }
					isPressed={ isWordsInputVisible }
					variant="tertiary"
				>
					{ __( 'Create from words' ) }
					<span class="imgwb-nav-counter">NEW</span>
				</Button> }
				{ mediaCreating && <>
					<Spinner /> Creating...
					</>
				}
				{ isWordsInputVisible && <Popover onClose={ closeWordsInput }>
					<form
						className="block-editor-media-placeholder__url-input-form"
						onSubmit={ onSubmitWords }
					>
						<input
							className="block-editor-media-placeholder__url-input-field"
							type="text"
							aria-label={ __( 'Words' ) }
							placeholder={ __( 'Paste or type words' ) }
							onChange={ (event) => setMediaWords(event.target.value) }
							style={{
								background: "url('/wp-content/plugins/image-plus/dall-e.png') no-repeat bottom right"
							}}
						/>
						<Button
							className="block-editor-media-placeholder__url-input-submit-button"
							icon={ keyboardReturn }
							label={ __( 'Powered by OpenAI Dall-E' ) }
							type="submit"
						/>
					</form>
				</Popover> }
			</div>
		);


		function renderAdd() {
			return (
				<MediaPlaceholder
					icon={ <Icon icon="format-image" /> }
					labels={ {
						title: title || 'Add Image',
						instructions: instructions || 'Upload an image file, pick one from your media library, add one from a URL, or create one using AI',
					} }
					multiple = { false }
					allowedTypes = { [ 'image' ] }
					accept="image/*"
					onSelect={ onSelectImage }
					onSelectURL={ onSelectURL }
					handleUpload={ true }
					onError={ onUploadError }
					children={ openai }
				/>
			)
		}

		return blobUrl ? renderUploading() : renderAdd();
	}

	function mainNav() {

		let tabs = [
			{
				name: 'images',
				title: 'Images',
				content: selectVariant()
			},
			{
				name: 'goal',
				title: 'Goal',
				content: navGoal()
			},
			{
				name: 'speed',
				title: 'Speed',
				content: navSpeed()
			},
			{
				name: 'control',
				title: 'Control',
				content: navControl()
			}
		];

		if (suggested_variants.length) {
			const suggestion_tab_title = wp.element.createElement(
				'span', null, 'Try This...',
				wp.element.createElement('span', { className: 'imgwb-nav-counter' }, suggested_variants.length)
			);

			tabs.push({
				name: 'suggestion',
				title: suggestion_tab_title,
				content: navSuggestion()
			});
		}

		return (
			<TabPanel
				className="imgwb-main"
				orientation="vertical"
				activeClass="active-tab"
				children={ (tab) => tab.content }
				initialTabName={ mainNavTab }
				onSelect={ ( value ) => setMainNavTab(value) }
				tabs={ tabs }
			/>
		);
	}

	function selectVariant() {

		function getVariantProps(variant_id) {
			let variant_props = {
				className: 'imgwb-thumb',
				'data-variant': variant_id
			}

			if (variant_id == attributes.variant_id) {
				variant_props.className += ' imgwb-variant-editing';
			}

			return variant_props;
		}

		function setVariantValue(variant_id, field, value) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						[field]: value
					}
				}
			});

			// after Deactivate
			if (field == 'variant_status' && value == 'inactive') {
				setAttributes({
					'variant_id': primary_variant_id
				})
			}
		}

		function duplicateVariant(variant) {
			setAttributes({
				from_src: variant.source_url,
				variants: {
					...attributes.variants,
					'new': {
						...variant,
						label: 'Copy of '+variant.label,
						variant_type: 'alt',
						variant_status: 'duplicating'
					}
				}
			})
		}

		function variantStrip() {
			function getMenuItems(variant_id, variant) {
				let items = [
					{
						title: 'Settings',
						icon: 'admin-settings',
						onClick: () => void 0
					},
					{
						title: 'Duplicate',
						icon: 'admin-page',
						isDisabled: !variant.source_url,
						onClick: () => duplicateVariant(variant)
					}
				];

				if (variant.variant_status != 'inactive') {
					items.push({
						title: 'Deactivate',
						icon: 'trash',
						isDisabled: variant.variant_type == 'baseline' || variant.variant_type == 'primary',
						onClick: () => setVariantValue(variant_id, 'variant_status', 'inactive')
					})
				} else {
					items.push({
						title: 'Reactivate',
						icon: 'undo',
						onClick: () => setVariantValue(variant_id, 'variant_status', 'active')
					})
				}

				return items;
			}

			return (
				<div class="imgwb-variant-strip">
					{ best_variants.map(([variant_id, variant]) => {
						if (variant.variant_status == 'inactive' && !showDeletedVariants) return;

						return (
							<div { ...getVariantProps(variant_id) }
								onClick={ () => setAttributes({ variant_id }) }
							>
								{ variant_id == winning_variant && !!variant.ctvr &&
								<>
									<div className="imgwb-winning-ribbon">
										<img
											src="/wp-content/plugins/image-plus/ribbon.png"
											width="60"
										/>
									</div>
									<div className="imgwb-winning-ctvr"
										title="This image has the highest click-to-view ratio"
									>
										{ variant.ctvr >= 100 ? parseInt(variant.ctvr) : variant.ctvr.toPrecision(2) + '%' }
									</div>
								</> }
								<div className="imgwb-preview-header">
									<TextControl
										className="imgwb-variant-label"
										value={ variant.label }
										onChange={ (value) => setVariantValue(variant_id, 'label', value) }
									/>
									<DropdownMenu
										icon="menu-alt2"
										label="Actions"
										controls={ getMenuItems(variant_id, variant) }
									/>
								</div>
								{ variantPreview(variant_id, variant) }
								{ variantStatus(variant_id, variant) }
							</div>
						);
					}) }

					{ Object.keys(attributes.variants).length > 2 && <InspectorControls>
						<PanelBody title="Multiple Images">
							<RadioControl
								selected={ attributes.rotation }
								options={ [
									{
										label: wp.element.createElement(
											'span', null, 'Simple Rotation', wp.element.createElement(
												'div', { className: 'imgwb-inspector-help' }, 'Show alternative images in equal amounts, to freshen your viewer experience. You can manually review which images are working best.'
											)
										),
										value: 'simple'
									}
								] }
								onChange={ ( rotation ) => setAttributes({ rotation }) }
							/>
							<Disabled>
								<RadioControl
									selected={ attributes.rotation }
									options={ [
										{
											label: wp.element.createElement(
												'span', null, 'Advanced AI Rotation', wp.element.createElement(
													'div', { className: 'imgwb-inspector-help' }, 'Automatically learn which images are working best, and show those more often. Requires a paid plan.'
												)
											),
											value: 'ai'
										}
									] }
									onChange={ ( rotation ) => setAttributes({ rotation }) }
								/>
							</Disabled>
							<hr/>
							{ (inactive_variants_count > 0) && <CheckboxControl
								label={ "Show " + inactive_variants_count + " inactive image" + (inactive_variants_count > 1 ? 's' : '') }
								checked={ showDeletedVariants }
								onChange={ () => setShowDeletedVariants(!showDeletedVariants) }
							/> }
							<CheckboxControl
								label={
									wp.element.createElement(
										'span', null, 'Display alternative images at the same height', wp.element.createElement(
											'div', { className: 'imgwb-inspector-help' }, 'Recommended, to improve your ', wp.element.createElement(
												'a', { href: 'https://web.dev/vitals/', target: '_blank' }, 'SEO rankings'
											),
										'.')
									)
								}
								checked={ attributes.lock_aspect_ratio }
								onChange={ (lock_aspect_ratio) => setAttributes({ lock_aspect_ratio }) }
							/>
						</PanelBody>
					</InspectorControls> }

				</div>
			);
		}

		function getImageLink() {
			return {
				url: attributes.link,
				opensInNewTab: attributes.link_blank
			}
		}

		function setImageLink(value) {
			setAttributes({
				link: value.url,
				link_blank: value.opensInNewTab
			})
		}

		return (
			<div>
				<div className="imgwb-benefit-message">Optimize engagement and impact by split-testing alternative images!</div>
				<Text>
					Select an image below to adjust settings, or &nbsp;
				</Text>
				<Button
					style={{
						'vertical-align': 'middle',
						'margin-top': '2px'
					}}
					variant="primary"
					icon=<Icon icon="plus" className="text" />
					iconSize="42"
					text="Add an alternative image"
					label="Your best performing images will be shown more often."
					showTooltip={ true }
					onClick={ () => setShowAddVariant(!showAddVariant) }
				/>

				<BlockControls>
					<ToolbarGroup>
						<Dropdown
							position="bottom right"
							renderToggle={ ( { isOpen, onToggle } ) => (
								<ToolbarButton
									showTooltip
									icon="admin-links"
									onClick={ onToggle }
									label="Link"
								/>
							) }
							renderContent={
								() => <LinkControl
									value={ getImageLink() }
									onChange={ (value) => { setImageLink(value) } }
								/>
							}
						/>
					</ToolbarGroup>
				</BlockControls>

				{ !showAddVariant && variantStrip() }

				{ showAddVariant && addMedia("Add Alternative Image", "Your best performing images will be shown more often.") }

				{ !showAddVariant && attributes.variant_id && attributes.variant_id != 'new' && variantSettings() }
			</div>
		);
	}

	// used for thumbs and full-size preview
	function variantPreview(variant_id, variant) {

		//console.log(attributes, 'variantPreview', variant_id, variant);
		if (!variant) return;

		// until source is loaded
		// baseline gets redirect without svg decoration
		if (variant.variant_type == 'baseline' || !variant.width || !variant.height) {
			return (
				<img
					src={ variant.source_url }
					alt={ variant.label }
					title={ variant.label }
				/>
			)
		}

		function getSVGProps(variant, x_offset) {
			return {
				version: '1.1',
				xmlns: 'http://www.w3.org/2000/svg',
				// x is offset 10% for slideshow.slide to enable slow animation
				viewBox: (x_offset || 0) + ' 0 ' + variant_locked_field(variant, 'width') + ' ' + variant_locked_field(variant, 'height'),
				preserveAspectRatio: "xMidYMid slice"
			}
		}

		// unique list of fonts to download
		function getFonts() {
			let fonts = {};
			variant.params?.captions?.forEach(function(_caption) {
				if (_caption.font_family) fonts[_caption.font_family] = true;
			});

			const font_names = Object.keys(fonts).join('|').replace(' ', '+');
			if (font_names) {
				return "@import url('https://fonts.googleapis.com/css?family=" + font_names + "');";
			}
		}

		function getImageHref(variant_id, variant) {
			// transform preview
			if (attributes.from_src) {
				return attributes.from_src;
			} else if (variant.variant_id == 'new' || variant.variant_status == 'loading') {
				return variant.source_url;
			}

			return getImageSrc(variant_id);
		}

		function getFocusProps(variant) {
			if (variant.params?.focus?.zoom) {
				// box 123234345456:Face One
				//
				let focus_x = 0.5;
				let focus_y = 0.5;
				if (variant.params?.focus?.box) {
					const _box = variant.params.focus.box;
					focus_x = parseFloat('0.'+_box.substring(0, 3)) + 0.5*parseFloat('0.'+_box.substring(6, 9));
					focus_y = parseFloat('0.'+_box.substring(3, 6)) + 0.5*parseFloat('0.'+_box.substring(9, 12));
				}

				let rv = {
					'style' : {
						'transform-origin': (100 * focus_x) + '% ' + (100 * focus_y) + '%',
						'transform-box': 'fill-box'
					}
				};

				if (variant.params?.focus?.zoom < 0) {
					const initial_zoom = 1.0 + Math.abs(variant.params.focus.zoom);
					rv['transform'] = 'scale(' + initial_zoom + ')';
				}

				return rv;
			}
		}

		function getFocusAnimation(variant, begin, duration) {
			if (typeof variant.params?.focus?.zoom != 'undefined') {
				const zoom = 1.0 + Math.abs(variant.params.focus.zoom);
				let animate_values;
				if (variant.params.focus.zoom > 0) {
					animate_values = [1, zoom];
				} else {
					animate_values = [zoom, 1];
				}

				return (
					<animateTransform
						attributeName="transform"
						type="scale"
						begin={ begin }
						dur={ duration }
						keyTimes="0; 1"
						values={ animate_values.join('; ') }
						calcMode="spline"
						keySplines=".2 .7 .5 1"
						fill='freeze'
					/>
				);
			}
		}

		// slideshow has 10% gutter to enable slow slide
		function svgCaptions(gutter=0) {

			return (
				<>
					{ variant.params?.captions?.map((caption, idx) => {
						return (
							<svg
								x={ gutter + parseFloat(typeof caption.x !== 'undefined' ? caption.x : (variant.width-caption.width)/2) }
								y={ parseFloat(typeof caption.y !== 'undefined' ? caption.y : (variant.height-caption.height)/2) }
							>
								<rect
									x="0"
									y="0"
									width={ caption.width }
									height={ caption.height }
									fill-opacity="0"
								/>
								<rect
									x="0"
									y="0"
									width="0"
									height={ caption.height }
									fill={ caption.bgcolor }
								>
									{ typeof caption.begin !== 'undefined' && <animate
										attributeName="width"
										begin="0s"
										dur={ (caption.begin + 0.3) + 's' }
										keyTimes={ '0; ' + caption.begin/(caption.begin + 0.3) + '; 1' }
										values={ '0; 0; ' + caption.width }
										calcMode="spline"
										keySplines="0 0 1 1; .2 .7 .5 1"
										fill="freeze"
									/> }
								</rect>
								<text
									data-variant={ variant_id }
									x={ 0.5 * caption.width }
									y={ 0.5 * caption.height }
									dominant-baseline="central"
									style={{
										textAnchor: 'middle',
										fontWeight: caption.font_weight || 400,
										opacity: 0
									}}
									fill={ caption.color }
									font-size={ caption.font_size }
									font-family={ caption.font_family }
								>
									{ caption.text }
									{ typeof caption.begin !== 'undefined' && <animate
										attributeName="opacity"
										attributeType="css"
										begin="0s"
										dur={ (caption.begin + 0.2) + 's' }
										keyTimes={ '0; ' + caption.begin/(caption.begin + 0.2) + '; 1' }
										values='0; 0; 1'
										calcMode="spline"
										keySplines="0 0 1 1; .2 .7 .5 1"
										fill="freeze"
									/> }
								</text>
								{ typeof caption.end !== 'undefined' && <animate
									attributeName="opacity"
									attributeType="css"
									begin="0s"
									dur={ (caption.end + 0.2) + 's' }
									keyTimes={ '0; ' + caption.end/(caption.end + 0.2) + '; 1' }
									values='1; 1; 0'
									fill="freeze"
								/> }
							</svg>
						);
					}) }
				</>
			);
		}

		// variant_template: focus slideshow crossfade
		if (variant.variant_template == 'focus') {
			return (
				<svg { ...getSVGProps(variant) }>
					<title>{ variant.label + (isSelected ? '\n' + 'Click to adjust settings' : '') }</title>
					<style type="text/css">
						{ getFonts() }
					</style>
					<g { ...getFocusProps(variant) }>
						<image
							href={ getImageHref(variant_id, variant) }
							x="0" y="0"
							width={ variant_locked_field(variant, 'width') }
							height={ variant_locked_field(variant, 'height') }
							preserveAspectRatio="xMidYMid slice"
						/>
						{ getFocusAnimation(variant, '0s', (variant.params?.focus?.duration || 2)+'s') }
					</g>
					{ svgCaptions() }
				</svg>
			);
		}

		// combo templates need some extra calcs...
		const combo_length = Object.keys(combo_variants).length;

		// _ underscore character is randomized after svg is injected if multiple instances
		const loop_id = '_loop' + Date.now();

		// offset - start animation early while sliding or crossfading from previous
		function getBegin(idx, offset=0, part_duration, total_duration) {
			const bb = ((idx-offset) * part_duration + total_duration) % total_duration;
			let begin = loop_id + '.begin+' + bb + 's';
			if (!idx) {
				// TODO contributes to restart judder
				begin = (idx-offset) * part_duration + 's; ' + begin;
			}
			return begin;
		}

		if (variant.variant_template == 'slideshow') {

			const part_duration = (variant.params?.slideshow?.duration || 5);
			const total_duration = combo_length * part_duration;

			let key_times = [];
			let anim_values = [];
			let key_splines = [];

			for (let idx = 0; idx < combo_length; idx++) {
				key_times.push(idx/combo_length);
				key_times.push((idx+0.6)/combo_length);

				anim_values.push(idx * -1.2 * primary_variant.width + ' 0');
				anim_values.push(idx * -1.2 * primary_variant.width + ' 0');

				key_splines.push('0 0 1 1');
				key_splines.push('.2 1 .2 .9');
			}
			key_times.push(1);
			anim_values.push(combo_length * -1.2 * primary_variant.width + ' 0');

			function getRepeatedImageProps(idx) {
				if (!idx) {
					return {
						id: '_i0'
					}
				}
			}

			function getSlideshowCropper() {
				const north = 0;
				const east = variant.width * 1.1;
				const south = variant.height;
				const west = variant.width * 0.1;

				const north_west = variant.width * 0.2 + ',' + variant.height * 0.2;
				const north_east = variant.width + ',' + variant.height * 0.1;
				const south_east = variant.width + ',' + variant.height * 0.9;
				const south_west = variant.width * 0.2 + ',' + variant.height * 0.8;

				const no_crop = `M ${west},${north} ${west},${south} ${east},${south} ${east},${north} ${west},${north} Z M ${west},${north} ${east},${north} ${east},${south} ${west},${south} Z`;
				const crop = `M ${west},${north} ${west},${south} ${east},${south} ${east},${north} ${west},${north} Z M ${north_west} ${north_east} ${south_east} ${south_west} Z`;

				let begins = [];
				for (let idx=0; idx < combo_variants.length; idx++) {
					begins.push((idx * part_duration) + 's; ' + loop_id + '.end+' + (idx * part_duration) + 's');
				}

				return (
					<path fill="#FFFFFF" d={ no_crop }>
						<animate
							 attributeName="d"
							 begin={ begins.join('; ') }
							 dur={ part_duration + 's' }
							 keyTimes="0; .53; .54; .7; .725; 1"
							 values={ [no_crop, no_crop, crop, crop, no_crop, no_crop].join('; ') }
						/>
					</path>
				);
			}

			if (!primary_variant) return;

			let repeated_variant;

			return (
				<svg { ...getSVGProps(primary_variant, 0.1 * primary_variant.width) }>
					<title>{ variant.label }</title>
					<style type="text/css">
						{ getFonts() }
					</style>
					<defs>
					{ [...Array(1+combo_length)].map((_, idx) => {
						return (
							<clipPath id={ '_cp' + idx }>
								<rect
									x={ idx * 1.2 * primary_variant.width }
									y="0"
									width={ 1.2 * primary_variant.width }
									height={ primary_variant.height }
								/>
							</clipPath>
						);
					}) }
					</defs>
					<g>
						<animateTransform attributeName="transform" type="translate"
							id={ loop_id }
							begin={ '0s; ' + loop_id + '.end' }
							dur={ total_duration + 's' }
							keyTimes={ key_times.join('; ') }
							values={ anim_values.join('; ') }
							calcMode="spline"
							keySplines={ key_splines.join('; ') }
							//restart='whenNotActive'
						/>
					{ combo_variants.map(([variant_id, variant], idx) => {
						if (!idx) {
							repeated_variant = variant;
						}

						return (
							<g style={{
								'clip-path': 'url(#_cp' + idx + ')'
							}}>
								<g { ...getFocusProps(variant) }>
									<image { ...getRepeatedImageProps(idx) }
										href={ getImageHref(variant_id, variant) }
										x={ idx * 1.2 * primary_variant.width }
										y="0"
										width={ 1.2 * primary_variant.width }
										height={ primary_variant.height }
										preserveAspectRatio="xMidYMid slice"
									/>
									{ getFocusAnimation(variant, getBegin(idx, 0.4, part_duration, total_duration), part_duration) }
								</g>
							</g>
						);
					}) }
								<g style={{
									'clip-path': 'url(#_cp' + combo_variants.length + ')'
								}}>
									<g { ...getFocusProps(repeated_variant) }>
										<use
											href="#_i0"
											x={ combo_variants.length * 1.2 * primary_variant.width }
											y="0"
											preserveAspectRatio="xMidYMid slice"
										/>
										{ getFocusAnimation(repeated_variant, getBegin(0, 0.4, part_duration, total_duration), part_duration) }
									</g>
								</g>
					</g>
					{ getSlideshowCropper() }
					{ svgCaptions(0.1 * variant.width) }
				</svg>
			);

		}

		// crossfade
		if (variant.variant_template == 'crossfade') {

			const part_duration = (variant.params?.crossfade?.duration || 5);
			const total_duration = combo_length * part_duration;

			function animate_crossfade(idx) {
				let anim_props = {
					attributeName: 'opacity',
					attributeType: 'css',
					begin: "0s; " + loop_id + ".end",
					dur: total_duration + 's',
					//restart: 'whenNotActive'
				}

				let key_times;
				if (!idx) {
					anim_props['id'] = loop_id;
					anim_props['values'] = "1; 1; 0; 0; 1; 1";
					key_times = [0, 0.4/combo_variants.length, 0.6/combo_variants.length, 1-0.6/combo_variants.length, 1-0.4/combo_variants.length, 1];

				} else {
					anim_props['values'] = "0; 0; 1; 1; 0; 0";
					const center = idx/combo_variants.length;
					key_times = [0, center-0.6/combo_variants.length, center-0.4/combo_variants.length, center+0.4/combo_variants.length, center+0.6/combo_variants.length, 1];
				}
				anim_props['keyTimes'] = key_times.join('; ');

				return (
					<animate
						{ ...anim_props }
					/>
				);
			}

			if (!primary_variant) return;

			return (
				<svg { ...getSVGProps(primary_variant) }>
					<title>{ variant.label }</title>
					<style type="text/css">
						{ getFonts() }
					</style>
					{ combo_variants.map(([variant_id, variant], idx) => {
						return (
							<g { ...getFocusProps(variant) }>
								<image
									opacity={ !idx ? 1 : 0 }
									href={ getImageHref(variant_id, variant) }
									x="0"
									y="0"
									width={ primary_variant.width }
									height={ primary_variant.height }
									preserveAspectRatio="xMidYMid slice"
								>
									{ animate_crossfade(idx) }
								</image>
								{ getFocusAnimation(variant, getBegin(idx, 0.6, part_duration, total_duration), part_duration) }
							</g>
						);
					}) }
					{ svgCaptions() }
				</svg>
			);

		}

	}

	function variantStatus(variant_id, variant) {
		//console.log('status', variant_id, variant);

		// new for Transform, loading for waiting for server
		if (variant_id == 'new' || variant.variant_status == 'loading') {
			return (
				<div className="imgbw-preview-footer">
					<div>
						<Spinner/>
						<span style={{
							'vertical-align' : 'text-bottom'
						}}>Loading...</span>
					</div>
				</div>
			);
		}

		// pie chart
		const views = getRollingViewCount(variant);
		const mix = viewTotal ? (views / viewTotal) : 0;
		const endX = Math.cos(2 * Math.PI * Math.max(0.01, mix));
		const endY = Math.sin(2 * Math.PI * Math.max(0.01, mix));
		const largeArcFlag = (mix > .5) ? 1 : 0;
		const pie_path = [
			`M 1 0`, // Move
			`A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
			`L 0 0`, // Line
		].join(' ');

		let mix_title = '[' + (variant.variant_status || 'loading').toUpperCase() + '] ' + parseInt(100*mix) + '% of views.';
		if (variant.variant_type == 'baseline') {
			mix_title += '\nYour baseline image will be shown (free of charge) to some viewers, to measure baseline engagement, compared to your other images.'
		} else {
			mix_title += '\nYour best performing images will be shown more often.'
		}

		function getStatusPieClass() {
			let sp_class = 'imgwb-status-pie';

			if (edgePolicy[variant_id] == 'stale') {
				sp_class += ' imgwb-status-stale'
			}

			return sp_class;
		}

		const icon_pie_chart = (
			<svg
				class={ getStatusPieClass() }
				viewBox="-1.2 -1.2 2 2.6"
				width="20" height="20"
			>
				<title>
					{ mix_title }
				</title>
				<circle
					r="0.85"
					fill="none"
					stroke={ variant.variant_status == 'active' ? '#008450DD' : '#d63638' }
					stroke-width="0.1"
				/>
				<path
					d={ pie_path }
					fill={ variant.variant_status == 'active' ? '#008450DD' : '#d63638' }
				/>
			</svg>
		);

		let view_count, view_title = 'Rolling 7-day total:';
		if (variant.variant_type == 'baseline') {
			// could dig into asset numbers to distinguish loading/mix/overquota
			view_count = views ? views.toLocaleString() : '-';
			view_title += views ? '\n' + views.toLocaleString() + ' views (free of charge)' : ' no views';

		} else {
			view_count = views ? views.toLocaleString() : '-';
			view_title += views ? '\n' + views.toLocaleString() + ' views' : ' no views';
		}

		// tmp.
		if (variant.views_rolling) {
			view_title += '\n' + JSON.stringify(variant.views_rolling);
		}

		const clicks = variant.clicks_rolling?.click_web;

		return (
			<div className="imgbw-preview-footer">
				<div>
					<Icon icon={ icon_pie_chart } />
					{ mix ? (parseInt(100*mix) + '%') : '-' }
				</div>
				<div>
					<Icon icon="visibility" size="16"
						title={ view_title }
					/>
					{ view_count }
				</div>
				<div>
					<Icon icon="yes-alt" size="16"
						title={ 'Rolling 7-day total:' + (clicks ? '\n' + clicks.toLocaleString() + ' clicks\nClick-to-view ratio: ' + (variant.ctvr >= 100 ? parseInt(variant.ctvr) : variant.ctvr.toPrecision(2)) + '%' : ' no clicks') }
					/>
					{ clicks || '-' }
				</div>
				<div>
					<Icon icon="money-alt" size="16"
						title={ 'Select "Goal" to configure a downstream goal or conversion event from Google Analytics' }
					/>
					{ '-' }
				</div>
			</div>
		);
	}

	function variantSettings() {
		const variant = attributes.variants[attributes.variant_id];

		// TODO disable settings instead
		if (['active', 'inactive'].indexOf(variant.variant_status) == -1) {
			// loading, duplicating
			//return;
		}

		const tab_names = variant_template_settings[attributes.variants[attributes.variant_id].variant_template];

		const tab_lookup = {
			'baseline' : ['Baseline', variantBaselineSettings()],
			'focus' : ['Focus', variantFocusSettings()],
			'captions' : ['Captions', variantCaptionSettings()],
			'evolve' : ['Evolve', variantEvolveSettings()],
			'slideshow' : ['Slideshow', variantSlideshowSettings()],
			'crossfade' : ['Cross-Fade', variantCrossfadeSettings()]
		}

		const tabs = tab_names.map((name) => {
			return {
				name: name,
				title: tab_lookup[name][0],
				content: tab_lookup[name][1]
			}
		});

		// tabs depend on template
		return (
			<TabPanel
				className="imgwb-variant-settings"
				activeClass="active-tab"
				children={ (tab) => tab.content }
				initialTabName={ variantSettingsTab }
				onSelect={ ( value ) => setVariantSettingsTab(value) }
				tabs={ tabs }
			/>
		);
	}

	function variantBaselineSettings() {
		const variant_id = attributes.variant_id;
		const baseline = attributes.variants[variant_id]?.params?.baseline || {};

		function getBaselineValue(field, default_value) {
			return (typeof baseline[field] != 'undefined' ? baseline[field] : default_value);
		}

		function setBaselineValue(field, value) {
			setAttributes({
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							baseline: {
								...attributes.variants[variant_id]?.params?.baseline,
								[field]: value
							}
						}
					}
				}
			});
		}

		// TODO your account is over-quota until dd-mm-yy. Until then, all viewers will see your original source image, with branding added
		// TODO similar message on other variants, hide controls
		return (
			<>
				<div className="imgwb-benefit-message">Measure the baseline engagement of your original source image</div>
				<div>
					<p>This is your original image, without any benefits added.</p>
					<p>It will be shown to approx. { getBaselineValue('mix') }% of viewers - at no cost - to measure baseline engagement, compared to your other images.</p>
				</div>
				<Disabled>
					<RangeControl
						label="Baseline:"
						help="A paid plan is required to change this setting"
						min={ 0 }
						max={ 100 }
						step={ 1 }
						showTooltip={ false }
						value={ getBaselineValue('mix', 20) }
						onChange={ (value) => setBaselineValue('mix', value) }
					/>
				</Disabled>
			</>
		);
	}

	function variantFocusSettings() {
		const variant_id = attributes.variant_id;
		const focus = attributes.variants[variant_id]?.params?.focus || {};

		function getFocusValue(field, default_value) {
			return focus[field] || default_value;
		}

		function setFocusValue(field, value) {
			let new_focus = {
				...attributes.variants[variant_id]?.params?.focus,
				[field]: value
			};

			// default zoom
			if (field == 'box' && !new_focus.zoom) {
				new_focus.zoom = 0.5;
			}

			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							focus: new_focus
						}
					}
				}
			});

			document.querySelector('.imgwb-variant-editing svg').dataset.restart = 0;
			setAnimationRestart(Date.now());
		}

		// list of focal boxes
		function getBoxOptions() {
			if (attributes.variants[variant_id]?.variant_status == 'loading') {
				return [{
					label: 'Your image is being analyzed...',
					value: 'loading'
				}];

			} else {
				return attributes.variants[variant_id]?.foci?.map(function(box, idx) {
					return { label: box.split(':')[1], value: box };
				});
			}
		}

		/*
					<ToggleControl
						label="Add Some Sparkle"
						className="imgwb-sparkle-toggle"
						checked={ getFocusValue('sparkle', false) }
						onChange={ (value) => setFocusValue('sparkle', value) }
					/>
		*/

		return (
			<>
				<div className="imgwb-benefit-message">Increase viewer engagement by focussing attention!</div>
				<div className="imgwb-variant-settings-focus">
					<SelectControl
						label="Focus"
						help="Choose what to focus viewer attention on"
						value={ getFocusValue('box') }
						options={ getBoxOptions() }
						onChange={ (value) => setFocusValue('box', value) }
					/>
					<RangeControl
						label="Zoom"
						value={ getFocusValue('zoom', '0') }
						min={ -3 }
						max={ 3 }
						step={ 0.05 }
						showTooltip={ false }
						onChange={ (value) => setFocusValue('zoom', value) }
						beforeIcon=<Icon icon="remove" className="text" />
						afterIcon=<Icon icon="insert" className="text" />
					/>
					<NumberControl
						label="Duration"
						min="0.1"
						step="0.1"
						value={ getFocusValue('duration', '2') }
						onChange={ (value) => setFocusValue('duration', parseFloat(value)) }
					/>
				</div>
			</>
		)

	}

	function variantSlideshowSettings() {
		const variant_id = attributes.variant_id;
		const slideshow = attributes.variants[variant_id]?.params?.slideshow || {};

		function getSlideshowValue(field, default_value) {
			return slideshow[field] || default_value;
		}

		function setSlideshowValue(field, value) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							slideshow: {
								...attributes.variants[variant_id]?.params?.slideshow,
								[field]: value
							}
						}
					}
				}
			});

			//document.querySelector('.imgwb-variant-editing svg').dataset.restart = 0;
			//setAnimationRestart(Date.now());
		}

		return (
			<>
				<div className="imgwb-benefit-message">Increase viewer engagement with an eye-catching infinite slideshow!</div>
				<NumberControl
					label="Duration"
					min="1"
					step="0.1"
					value={ getSlideshowValue('duration', '5') }
					onChange={ (value) => setSlideshowValue('duration', parseFloat(value)) }
				/>
			</>
		);
	}

	function variantCrossfadeSettings() {
		const variant_id = attributes.variant_id;
		const crossfade = attributes.variants[variant_id]?.params?.crossfade || {};

		function getCrossfadeValue(field, default_value) {
			return crossfade[field] || default_value;
		}

		function setCrossfadeValue(field, value) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							crossfade: {
								...attributes.variants[variant_id]?.params?.crossfade,
								[field]: value
							}
						}
					}
				}
			});

			//document.querySelector('.imgwb-variant-editing svg').dataset.restart = 0;
			//setAnimationRestart(Date.now());
		}

		return (
			<>
				<div className="imgwb-benefit-message">Increase viewer engagement with an eye-catching infinite crossfade!</div>
				<NumberControl
					label="Duration"
					min="1"
					step="0.1"
					value={ getCrossfadeValue('duration', '4') }
					onChange={ (value) => setCrossfadeValue('duration', parseFloat(value)) }
				/>
			</>
		);
	}

	function variantCaptionSettings() {

		const variant_id = attributes.variant_id;
		const variant = attributes.variants[variant_id];
		const palette = palettes[variant_id];

		// use primary to calculate font_size_auto and caption positions if we are locked
		const variant_width = variant_locked_field(variant, 'width');
		const variant_height = variant_locked_field(variant, 'height');

		const default_caption = {
			begin: 0,
			gravity: 'bottom center',
			font_family: 'Montserrat',
			font_size: parseInt(variant.width/12),
			font_weight: 500,
			width: 0,
			height: 0,
			bgcolor: (palette?.Vibrant?.color || palette?.LightVibrant?.color || '#800000') + 'dd',
			color: palette?.Vibrant?.text_color || palette?.LightVibrant?.text_color || 'white'
		};

		const captions = variant?.params?.captions || [ default_caption ];

		function addCaption() {
			let begin = 0;
			if (captions.length) {
				begin = Math.max(...captions.map(function(caption) {
					return parseFloat(caption.end || 0);
				} ));
			}

			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							captions: [ ...captions, {
								...default_caption,
								begin: begin
							} ]
						}
					}
				}
			});
		}

		function deleteCaption(caption_idx) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							captions: captions.filter(function(caption, idx) {
								return idx != caption_idx;
							})
						}
					}
				}
			});

			setCaptionIdx(0);

			document.querySelector('.imgwb-variant-editing svg').dataset.restart = 0;
			setAnimationRestart(Date.now());
		}

		function getCaptionValue(caption_idx, field, default_value) {
			let rv;
			if (caption_idx < captions.length) {
				rv = captions[caption_idx][field];
			}

			if (typeof rv == 'undefined') rv = default_value;
			//console.log('get', variant_id, caption_idx, field, rv);
			return rv;
		}

		function setCaptionValue(caption_idx, field, value) {
			const new_captions = variant?.params?.captions || [ default_caption ];

			new_captions[caption_idx][field] = value;

			// auto-adjust font_size
			if ((field == 'text' || field == 'font_size_auto' || field == 'font_family') && new_captions[caption_idx]['font_size_auto']) {
				new_captions[caption_idx].font_size = parseInt(variant_width / (Math.max(8, new_captions[caption_idx]['text'].length)));
			}

			// auto-adjust x,y based on text, font_size, font_size_auto, font_family, gravity
			if (['text', 'font_size', 'font_size_auto', 'font_family', 'gravity'].indexOf(field) != -1) {

				switch (new_captions[caption_idx].gravity) {
					case null:
						break;

					case 'top left':
						new_captions[caption_idx].x = 0;
						new_captions[caption_idx].y = 0;
						break;
					case 'top center':
						new_captions[caption_idx].x = (variant_width - new_captions[caption_idx].width)/2;
						new_captions[caption_idx].y = 0;
						break;
					case 'top right':
						new_captions[caption_idx].x = variant_width - new_captions[caption_idx].width;
						new_captions[caption_idx].y = 0;
						break;
					case 'center left':
						new_captions[caption_idx].x = 0;
						new_captions[caption_idx].y = (variant_height - new_captions[caption_idx].height)/2;
						break;
					case 'center center':
						new_captions[caption_idx].x = (variant_width - new_captions[caption_idx].width)/2;
						new_captions[caption_idx].y = (variant_height - new_captions[caption_idx].height)/2;
						break;
					case 'center right':
						new_captions[caption_idx].x = variant_width - new_captions[caption_idx].width;
						new_captions[caption_idx].y = (variant_height - new_captions[caption_idx].height)/2;
						break;
					case 'bottom left':
						new_captions[caption_idx].x = 0;
						new_captions[caption_idx].y = variant_height - new_captions[caption_idx].height;
						break;
					case 'bottom center':
						new_captions[caption_idx].x = (variant_width - new_captions[caption_idx].width)/2;
						new_captions[caption_idx].y = variant_height - new_captions[caption_idx].height;
						break;
					case 'bottom right':
						new_captions[caption_idx].x = variant_width - new_captions[caption_idx].width;
						new_captions[caption_idx].y = variant_height - new_captions[caption_idx].height;
				}
			}

			// auto-apply recommended text color from palette
			if (field == 'bgcolor') {
				if (palette) {
					for (let swatch in Object.values(palette)) {
						if (swatch.color == value) {
							new_captions[caption_idx].color = swatch.text_color;
							break;
						}
					}
				}
			}

			// exact width, height calculated in useEffect
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						params: {
							...attributes.variants[variant_id]?.params,
							captions: new_captions
						}
					}
				}
			});

			//console.log('set', variant_id, caption_idx, field, value);

			// setup restart.begin when caption is visible, so changes are observable
			document.querySelector('.imgwb-variant-editing svg').dataset.restart = new_captions[caption_idx].begin + 0.3;
			setAnimationRestart(Date.now());
		}

		function getPaletteColors(field) {
			let colors = []

			if (palette) {
				Object.entries(palette).forEach(function([swatch_id, swatch]) {
					colors.push({
						name: swatch_id,
						// default alpha
						color: swatch.color + (field == 'bgcolor' ? 'dd' : '')
					})
				});
			}

			if (field == 'color') {
				colors.push({
					name: 'White',
					color: 'white'
				});
			} else {
				colors.push({
					name: 'Transparent',
					color: 'transparent'
				});
			}

			colors.push({
				name: 'Black',
				color: 'black'
			});

			return colors;
		}

		let advanced_settings_button;
		// not needed if sidebar already open
		if (!document.querySelector('.edit-post-sidebar')) {
			advanced_settings_button = (
				<Button
					icon=<Icon icon="admin-generic" />
					onClick={ () => wp.data.dispatch( 'core/edit-post' ).openGeneralSidebar( 'edit-post/block' ) }
				/>
			);
		}

		return (
			<>
				<div className="imgwb-benefit-message">Increase viewer engagement with eye-catching calls to action!</div>
				<table border="0" cellpadding="8" className="imgwb-captions-tbl">
					<thead>
						<tr>
							<td>Caption</td>
							<td>Start Time</td>
							<td>End Time (optional)</td>
							<td></td>
						</tr>
					</thead>
					<tbody>
					{ captions.map((caption, idx) => (
						<tr key={ idx } className={ idx == captionIdx ? 'imgwb-caption-editing' : 'imgwb-caption' }>
							<td class="imgwb-caption-text">
								<TextControl
									className={ (idx == captionIdx) ? 'apply-font' : null }
									style={{
										fontFamily: getCaptionValue(idx, 'font_family', '')
									}}
									value={ getCaptionValue(idx, 'text', '') }
									onChange={ (value) => setCaptionValue(idx, 'text', value) }
									onPaste={ (value) => setCaptionValue(idx, 'text', value) }
									onFocus={ () => setCaptionIdx(idx) }
								/>
							</td>
							<td>
								<NumberControl
									min="0"
									step="0.1"
									value={ getCaptionValue(idx, 'begin', 1) }
									onChange={ (value) => setCaptionValue(idx, 'begin', parseFloat(value)) }
									onFocus={ () => setCaptionIdx(idx) }
								/>
							</td>
							<td>
								<NumberControl
									min="0.1"
									step="0.1"
									value={ getCaptionValue(idx, 'end') }
									onChange={ (value) => setCaptionValue(idx, 'end', parseFloat(value)) }
									onFocus={ () => setCaptionIdx(idx) }
								/>
							</td>
							<td>
								{ advanced_settings_button }
								<Button
									icon=<Icon icon="trash" />
									onClick={ () => deleteCaption(idx) }
								/>
							</td>
						</tr>
					)) }
					</tbody>
					<tfoot>
						<tr>
							<td colspan="3">
								<Button
									variant="secondary"
									icon=<Icon icon="plus" />
									text="Add"
									onClick={ addCaption }
								/>
							</td>
						</tr>
					</tfoot>
				</table>

				<InspectorControls>
					<PanelBody title={ __( 'Advanced Caption Settings' ) }>
							<div className="imgwb-inspector-heading">Position</div>

							<div className="imgwb-caption-position">
								<AlignmentMatrixControl
									label="Position"
									value={ getCaptionValue(captionIdx, 'gravity') }
									onChange={ (value) => setCaptionValue(captionIdx, 'gravity', value) }
								/>

								<RangeControl
									className="imgwb-caption-slider-y"
									value={ getCaptionValue(captionIdx, 'y') }
									min={ 0 }
									max={ variant_height - getCaptionValue(captionIdx, 'height') }
									trackColor='transparent'
									withInputField={ false }
									showTooltip={ false }
									onChange={ (value) => setCaptionValue(captionIdx, 'y', value) }
								/>

								<RangeControl
									className="imgwb-caption-slider-x"
									value={ getCaptionValue(captionIdx, 'x') }
									min={ 0 }
									max={ variant_width - getCaptionValue(captionIdx, 'width') }
									trackColor='transparent'
									withInputField={ false }
									showTooltip={ false }
									onChange={ (value) => setCaptionValue(captionIdx, 'x', value) }
								/>
							</div>

						<hr/>
							<div className="imgwb-inspector-heading">Font</div>
							<FontPicker
								apiKey="AIzaSyClVn2_Fc3IRARQTgCtr8pY9QR7A9-C1iE"
								activeFontFamily={ getCaptionValue(captionIdx, 'font_family', 'Montserrat') }
								onChange={ (value) => setCaptionValue(captionIdx, 'font_family', value.family) }
							/>

							<div className="imgwb-inspector-heading">
								Size
								<ToggleControl
									label="Auto"
									checked={ getCaptionValue(captionIdx, 'font_size_auto', true) }
									onChange={ (value) => setCaptionValue(captionIdx, 'font_size_auto', value) }
								/>
							</div>
							<RangeControl
								value={ getCaptionValue(captionIdx, 'font_size', 20) }
								disabled={ getCaptionValue(captionIdx, 'font_size_auto', true) }
								min={ parseInt(variant.width/32) }
								max={ parseInt(variant.width/6) }
								step={ 1 }
								onChange={ (value) => setCaptionValue(captionIdx, 'font_size', value) }
								beforeIcon=<Icon icon="remove" className="text" />
								afterIcon=<Icon icon="insert" className="text" />
							/>

							<div className="imgwb-inspector-heading">Weight</div>
							<RangeControl
								value={ getCaptionValue(captionIdx, 'font_weight', 400) }
								min={ 100 }
								max={ 900 }
								step={ 100 }
								onChange={ (value) => setCaptionValue(captionIdx, 'font_weight', value) }
							/>

						<hr/>
							<div className="imgwb-inspector-heading">Text Background</div>
							<ColorPalette
								colors={ getPaletteColors('bgcolor') }
								enableAlpha={ true }
								clearable={ false }
								value={ getCaptionValue(captionIdx, 'bgcolor') }
								onChange={ (value) => setCaptionValue(captionIdx, 'bgcolor', value) }
							/>

							<div className="imgwb-inspector-heading">Text Color</div>
							<ColorPalette
								colors={ getPaletteColors('color') }
								enableAlpha={ false }
								clearable={ false }
								value={ getCaptionValue(captionIdx, 'color') }
								onChange={ (value) => setCaptionValue(captionIdx, 'color', value) }
							/>

						<hr/>
							<div className="imgwb-inspector-heading">Link</div>
							<TextControl
								help="Specific to this caption"
								value={ getCaptionValue(captionIdx, 'link', '') }
								onChange={ (value) => setCaptionValue(captionIdx, 'link', value) }
							/>
							<ToggleControl
								label="Open in new tab"
								checked={ getCaptionValue(captionIdx, 'link_blank', false) }
								onChange={ (value) => setCaptionValue(captionIdx, 'link_blank', value) }
							/>
					</PanelBody>
				</InspectorControls>
			</>
		);
	}

	function variantEvolveSettings() {

		function getSuggestedImages() {
			setMediaCreating(true);

			apiFetch({
				path: '/imgwb_image_plus/api/openai',
				method: 'POST',
				data: {
					command: 'variations',
					prompt: evolvePrompt,
					n: 3
				}
			}).then(function(response) {
				console.log('POST /openai response', response);

				if (response.error) {
					setMediaCreating(false);
					setStatusNoticeLevel('error');
					setStatusNotice(response.error.message);
					setStatusActions(response.error.actions);

					// remove 'new' variant
					removeNewVariant()

				} else if (response.openai) {
					setMediaCreating(false);

					const new_suggestion_id = attributes.variant_id + '-evolve';
					const new_suggestion = {
						type: 'evolve',
						src_options: response.openai.map(function(image) {
							return image.url;
						})
					}
					console.log(new_suggestion);

					setShowAddVariant(false);

					// navigate to suggestions...
					setMainNavTab('suggestion');
				}
			});
		}

		return (
			<>
				<div className="imgwb-benefit-message">Create and improve images without waiting/paying for designers</div>
				<div>
					<p>Describe how you want to improve your image:</p>
				</div>

				<TextControl
					onChange={ (value) => setEvolvePrompt(value) }
				/>
				{ !mediaCreating && <Button
					variant="primary"
					text="Review suggested images &raquo;"
					onClick={ () => getSuggestedImages() }
				/> }
				{ mediaCreating && <>
					<Spinner /> Creating...
					</>
				}

			</>
		);
	}

	function navGoal() {

		return (
			<>
				<RadioControl
					label="Marketing Goal"
					selected={ attributes.goal }
					options={ [
						{ label: 'Get More Clicks', value: 'clicks' },
					] }
					onChange={ ( goal ) => setAttributes({ goal }) }
				/>
				<Disabled>
					<RadioControl
						help={ 'Connect your Google Analytics account to pick a downstream goal or conversion event, e.g. completing a "signup" form, or amount spent on your "checkout" page. Images that achieve more of your chosen goal will be show more often. Requires a paid plan.' }
						selected={ attributes.goal }
						options={ [
							{ label: 'Google Analytics Goal...', value: 'ga' }
						] }
						onChange={ ( goal ) => setAttributes({ goal }) }
					/>
				</Disabled>
			</>
		);
	}

	function navSpeed() {

		let flag;
		if (speed.country) {
			flag = (
				<img
					src={ 'https://imgwb.com/s/flags/' + speed.country.toLowerCase() + '.svg' }
					style={{
						float: 'right'
					}}
					width="64"
				/>
			)
		}

		return (
			<>
				<div className="imgwb-benefit-message">Faster loading images increase viewer engagement!</div>
				{ flag }
				<Disabled>
					<CheckboxControl
						label="Detect viewer location, and deliver images from nearby servers"
						help="Image+ delivers images from hundreds of locations around the globe"
						checked={ true }
					/>
				</Disabled>
				<Disabled>
					<CheckboxControl
						label="Detect screen size, and deliver images of optimal size"
						help="Image+ delivers your images faster to viewers on mobile devices"
						checked={ true }
					/>
				</Disabled>
				<div className="imgwb-benefit-message">Faster loading images also boost SEO rankings!</div>
				<Disabled>
					<CheckboxControl
						label="Detect browser support for new image formats, and deliver the best format"
						help="Image+ delivers JPEG, WEBP and AVIF images, whichever is best for each viewer"
						checked={ true }
					/>
				</Disabled>
				<Disabled>
					<CheckboxControl
						label="Detect mobile devices in 'low data' mode"
						help="Image+ delivers special 'low data' images to those devices"
						checked={ true }
					/>
				</Disabled>
				<div className="imgwb-benefit-message">Focus bandwidth on loading your hero images</div>

				<RadioControl
					label="Loading Speed"
					selected={ attributes.loading_speed }
					options={ [
						{
							label: wp.element.createElement(
								'span', null, 'Instant', wp.element.createElement(
									'div', { className: 'imgwb-inspector-help' }, 'Recommended for hero images. Display a low-resolution image during the few milliseconds your image is being transmitted over the internet.'
								),
								wp.element.createElement(
									'img', { src: attributes.instant_load_src, width: 100 }
								)
							),
							value: 'instant'
						},
						{
							label: 'Normal',
							value: 'eager'
						},
						{
							label: wp.element.createElement(
								'span', null, 'Lazy', wp.element.createElement(
									'div', { className: 'imgwb-inspector-help' }, 'Load image only when viewer scrolls it into view.'
								)
							),
							value: 'lazy'
						}
					] }
					onChange={ ( loading_speed ) => setAttributes({ loading_speed }) }
				/>
			</>
		);
	}

	function navControl() {

		return (
			<>
				<div className="imgwb-benefit-message">Stop others from using your images!</div>
				<Disabled>
					<CheckboxControl
						label="Prevent images from being displayed on other websites"
						help={ "Image+ will display your images only on " + location.origin + ". If someone attempts to display your images elsewhere, only your original image will be shown - at no cost." }
						checked={ true }
					/>
				</Disabled>
				<Disabled>
					<CheckboxControl
						label="Disable right-click context menu on images"
						help="Makes it harder for anyone to steal your images using 'Save as...'"
						checked={ true }
					/>
				</Disabled>
				<div className="imgwb-benefit-message">Control your costs! Requires a paid plan.</div>
				<Disabled>
					<CheckboxControl
						label="Set expiry date..."
						help="Afterwards, only your original image will be shown - at no cost"
						checked={ false }
					/>
				</Disabled>
				<Disabled>
					<CheckboxControl
						label="Limit image views..."
						help="Afterwards, only your original image will be shown - at no cost"
						checked={ false }
					/>
				</Disabled>
			</>
		);
	}

	function navSuggestion() {

		const suggestion = suggested_variants[suggestionIdx];
		if (!suggestion) {
			return;
		}

		function incSuggestionIdx() {
			setSuggestionIdx((suggestionIdx + 1) % suggested_variants.length);
		}

		function decrSuggestionIdx() {
			setSuggestionIdx((suggestionIdx - 1 + suggested_variants.length) % suggested_variants.length);
		}

		function setSuggestion(variant_id, variant_type) {
			setAttributes({
				cache_ver: String(Date.now()).substring(0, 10),
				variant_id: variant_id,
				variants: {
					...attributes.variants,
					[variant_id] : {
						...attributes.variants[variant_id],
						variant_type: variant_type,
						variant_status: variant_type == 'accepted' ? 'active' : 'inactive'
					}
				}
			});

			setSuggestionIdx(0);

			// goto images
			if (variant_type == 'accepted') {
				setMainNavTab('images');
			}
		}

		return (
			<>
				<div className="imgwb-suggestion-nav">
					{ suggested_variants.length > 1 && <Button
						className="imgwb-suggestion-back"
						variant="secondary"
						text="Back"
						onClick={ () => decrSuggestionIdx() }
					/> }
					<div>
						<div><b>Suggestion #{ 1+suggestionIdx }</b></div>
						<div>Here's an AI-created alternative image! Do you want to use it? If it performs better, it will start showing more often.</div>
					</div>
					{ suggested_variants.length > 1 && <Button
						className="imgwb-suggestion-next"
						variant="secondary"
						text="Next"
						onClick={ () => incSuggestionIdx() }
					/> }
				</div>
				<div className="imgwb-suggestion-preview">
					{ variantPreview(suggestion.variant_id, suggestion) }
				</div>
				<Button
					className="imgwb-suggestion-accept"
					variant="primary"
					text="Yes please! Add this alternative image!"
					onClick={ () => setSuggestion(suggestion.variant_id, 'accepted') }
				/>
				<Button
					className="imgwb-suggestion-reject"
					variant="link"
					text="No thank you. Keep trying!"
					onClick={ () => setSuggestion(suggestion.variant_id, 'rejected') }
				/>
			</>
		);
	}

	// subscribe to post save
	const { isSavingPost } = select( 'core/editor' );
	subscribe(() => {
		if (isSavingPost()) {
			setSavingProcess(true);
		} else {
			setSavingProcess(false);
		}
	});

	return (
		<div { ...useBlockProps() }>

			{ statusNotice && renderStatusNotice() }

			{ (!attributes.image_id || !Object.keys(attributes.variants).length) && addMedia('Get Started: Add Image') }

			{ attributes.image_id && !isSelected && !!Object.keys(attributes.variants).length && variantPreview(attributes.variant_id, attributes.variants[attributes.variant_id]) }

			{ attributes.image_id && isSelected && !!Object.keys(attributes.variants).length && mainNav() }

			{ false && <InspectorControls>
						<PanelBody title="Debug">
							{ JSON.stringify(attributes.variants[attributes.variant_id]) }
						</PanelBody>
					</InspectorControls> }

		</div>
	);
}
